import { z } from 'zod';

/////////////////////////////////////////
// CORE INTEGRATION DATA SYNC ADDITIONAL SETTING SCHEMA
/////////////////////////////////////////

export const CoreIntegrationDataSyncAdditionalSettingSchema = z.object({
  id: z.number().int(),
  cityId: z.number().int(),
  integrationId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  fieldKey: z.string(),
  stringValue: z.string(),
})

export type CoreIntegrationDataSyncAdditionalSetting = z.infer<typeof CoreIntegrationDataSyncAdditionalSettingSchema>

export default CoreIntegrationDataSyncAdditionalSettingSchema;
